var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata-wrap",style:({ width: _vm.wrapWidth, height: _vm.wrapHeight })},[_c('div',{staticClass:"nodata-inner"},[_c('img',{staticClass:"nodata-img",style:({ width: _vm.imgSize + 'px', height: _vm.imgSize + 'px' }),attrs:{"src":_vm.emptyImg,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('lang.OtherModule.k003')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }